// extracted by mini-css-extract-plugin
export default {"container":"News_container__HSJa7","date":"News_date__KUvuF"};